import { createAction } from 'redux-actions';

export const HIDE_LOADER = 'HIDE_LOADER';
export const hideLoader = createAction(HIDE_LOADER);

export const SHOW_LOADER = 'SHOW_LOADER';
export const showLoader = createAction(SHOW_LOADER);

export const SHOW_TOAST = 'SHOW_TOAST';
export const showToast = createAction(SHOW_TOAST);

export const SHOW_ERROR_TOAST = 'SHOW_ERROR_TOAST';
export const showErrorToast = createAction(SHOW_ERROR_TOAST);

export const SET_SERVER_TYPE = 'SET_SERVER_TYPE';
export const setServerType = createAction(SET_SERVER_TYPE);

export const UPDATE_FCM_TOKEN = 'UPDATE_FCM_TOKEN';
export const updateFCMToken = createAction(UPDATE_FCM_TOKEN);

export const SET_BRANCH_DATA = 'SET_BRANCH_DATA';
export const setBranchData = createAction(SET_BRANCH_DATA);

//this action used for after click the contest share
export const RESET_BRANCH_DATA = 'RESET_BRANCH_DATA';
export const resetBranchData = createAction(RESET_BRANCH_DATA);

export const GET_BANNER_LIST = 'GET_BANNER_LIST';
export const getBannerList = createAction(GET_BANNER_LIST);

export const SET_BANNER_LIST = 'SET_BANNER_LIST';
export const setBannerList = createAction(SET_BANNER_LIST);

export const GET_POPUP_LIST = 'GET_POPUP_LIST';
export const getPopupList = createAction(GET_POPUP_LIST);

export const SET_POPUP_DATA = 'SET_POPUP_DATA';
export const setPopupData = createAction(SET_POPUP_DATA);

export const SET_POPUP_LAST_SHOW_TIME = 'SET_POPUP_LAST_SHOW_TIME';
export const setPopupLastShowTime = createAction(SET_POPUP_LAST_SHOW_TIME);

export const GET_FACTS_LIST = 'GET_FACTS_LIST';
export const getFactsList = createAction(GET_FACTS_LIST);

export const SET_FACTS_DATA = 'SET_FACTS_DATA';
export const setFactsData = createAction(SET_FACTS_DATA);

export const SET_SERVER_DOWN = 'SET_SERVER_DOWN';
export const setServerDown = createAction(SET_SERVER_DOWN);

export const PING_SERVER = 'PING_SERVER';
export const pingServer = createAction(PING_SERVER);

export const UPDATE_SHARE_CONTEST_STATUS = 'UPDATE_SHARE_CONTEST_STATUS';
export const updateShareContestStatus = createAction(UPDATE_SHARE_CONTEST_STATUS);

export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const setCurrentLocation = createAction(SET_CURRENT_LOCATION);

export const SET_CURRENT_LOCATION_STATE = 'SET_CURRENT_LOCATION_STATE';
export const setCurrentLocationState = createAction(SET_CURRENT_LOCATION_STATE);

export const SET_NET_INFO_DATA = 'SET_NET_INFO_DATA';
export const setNetInfoData = createAction(SET_NET_INFO_DATA);

export const GET_WEB_BUILD_VERSION = 'GET_WEB_BUILD_VERSION';
export const getWebBuildVersion = createAction(GET_WEB_BUILD_VERSION);

export const SET_LAST_BUILD_CHECK_TIME = 'SET_LAST_BUILD_CHECK_TIME';
export const setLastBuildCheckTime = createAction(SET_LAST_BUILD_CHECK_TIME);

export const SET_MOBILE_LOCATION = 'SET_MOBILE_LOCATION';
export const setMobileLocation = createAction(SET_MOBILE_LOCATION);

export const SET_APP_LANGUAGE = 'SET_APP_LANGUAGE';
export const setAppLanguage = createAction(SET_APP_LANGUAGE);

export const SHOW_FEEDBACK_MODAL = 'SHOW_FEEDBACK_MODAL';
export const showFeedbackModal = createAction(SHOW_FEEDBACK_MODAL);

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const setActiveTab = createAction(SET_ACTIVE_TAB);
